import m from "../../geodata/es2015/samoaLow";
window.am4geodata_samoaLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/samoaLow.js
// module id = null
// module chunks = 